import '@repo/telemetry-config/instrumentation';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import { PiniaLogger } from 'pinia-logger';
import App from './App.vue';
import router from './router';

import { AuthConfig } from '@repo/core/security';
import { createAuth } from '@repo/vue/plugins';
import { createTheme } from '@/plugins/theme';

/*
 * All i18n resources specified in the plugin `include` option can be loaded
 * at once using the import syntax
 */
import messages from '@intlify/unplugin-vue-i18n/messages';

const i18n = createI18n({
  locale: 'en-ZA',
  messages
});

import '@/assets/styles.scss';
import '@/assets/tailwind.css';

const app = createApp(App);

const pinia = createPinia();
pinia.use(
  PiniaLogger({
    expanded: false,
    showDuration: true,
    showTime: true,
    logErrors: true,
    showPineapple: true,
    showStoreName: true
    // disabled: import.meta.env.MODE === 'production',
    // use a filter to only log certain actions
    // alternatively, you can specify the actions you want to log
    // if undefined, all actions will be logged
    // actions: ['decrementCounter']
  })
);

app.use(router);
app.use(pinia);
app.use(i18n);
app.use(createAuth(AuthConfig));
app.use(createTheme());

app.mount('#app');
